import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { TrackingService } from '../../helpers/services/tracking.service';

@Injectable({ providedIn: 'root' })
export class SampleOffersGuard implements CanActivate {
  constructor(private tracking: TrackingService, private router: Router) {}

  async canActivate(): Promise<boolean> {
    try {
      const metadata = await firstValueFrom(this.tracking.getSampleMetadata());
      if (metadata.actor?.role === 'vendor' && metadata.actor?.capabilities?.sample_vendor === true) return true;
    } catch { /* fail closed */ }
    await this.router.navigate(['pages/error-401']);
    return false;
  }
}
